import { Component } from '@angular/core';

@Component({
  selector: 'g99-lib-empty-notification-screen',
  templateUrl: './empty-notification-screen.component.html',
  styleUrl: './empty-notification-screen.component.scss',
  standalone: false,
})
export class EmptyNotificationScreenComponent {}
